<template lang="">
	<div>제품페이지</div>
</template>
<script>
export default {};
</script>
<style lang=""></style>
